import React from 'react';
import { Container } from 'reactstrap';
import CreateFormInput from '../CreateFormInput';
import { colors } from '../../Utils/Colors';
import { serverUrls } from '../../Utils/Urls';
import { getXray, getXrayFailure, getXraySuccess,resetXrayState } from '../../Actions/patientAction';
import { connect } from 'react-redux';
import axios from 'axios';

const formInputs = {
    pelvisPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'X-ray pelvis (AP view)'
    },
    lsPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Xray L-S Spine AP/lateral'
    },
    skullPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Xray Skull Lateral view'
    },
    wristPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Xray wrist joint (AP view)'
    },
    chestPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Xray Chest PA view'
    },
    anyotherPdf : {
        type: 'upload',
        placeholder: 'Pdf',
        label: 'Any Other Xray'
    },
}

class Xray extends React.Component {
    componentDidMount() {
      this.props.getXrayEdit(serverUrls.xray + this.props.id + '/');
    }
  
    componentWillUnmount() {
      this.props.resetXrayState();
    }
  
    render() {
      var url = serverUrls.xray + this.props.id + '/';
      return (
        <Container style={{ maxWidth: 800, background: colors.lightGrey }}>
          <br />
          <h4>X-ray</h4>
          <br />
          <CreateFormInput isPost={false} buttonName="Save" url={url} formName="getXray" inputs={formInputs} />
          <br />
          <br />
        </Container>
      );
    }
  }
  
  const mapStateToProps = () => {
    return {};
  };
  
  const mapDispatchToProps = (dispatch) => {
    return {
      getXrayEdit: (url) => {
        dispatch(getXray({ loading: true }));
        axios
          .get(url)
          .then((res) => {
            dispatch(
              getXraySuccess({
                loading: false,
                success: res.data.success,
                data: res.data,
              })
            );
          })
          .catch((err) => {
            dispatch(getXrayFailure({ loading: false }));
          });
      },
      resetXrayState: () => {
        dispatch(resetXrayState());
      },
    };
  };
  
  export default connect(mapStateToProps, mapDispatchToProps)(Xray);
